import { Action, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { patch } from '@ngxs/store/operators';
import { BridgesGameStateModel } from './bridges-game-states.model';
import * as actions from './bridges-game.actions';
import { PuzzleGameBaseState } from '../../puzzle-framework-module/puzzle-game-base.state';

// @dynamic
@State<BridgesGameStateModel>({
  name: 'bridgesGameStates',
  defaults: {
    puzzleGames: {},
  },
})
@Injectable()
export class BridgesGameState extends PuzzleGameBaseState {
  @Action(actions.InitBridgesGame)
  InitBridgesGame(state: StateContext<BridgesGameStateModel>, { payload }: actions.InitBridgesGame) {
    state.setState(
      patch({
        puzzleGames: patch({ [payload.puzzleID]: payload }),
      })
    );
  }

  @Action(actions.PersistBridgesState)
  PersistBridgesState(state: StateContext<BridgesGameStateModel>, { payload }: actions.PersistBridgesState) {
    state.setState(
      patch({
        puzzleGames: patch({
          [payload.puzzleID]: patch({
            bridges: payload.bridges,
          }),
        }),
      })
    );
  }
}
